export interface SummarizeNoveltyInputRequest {
    /**
     * 输入文本
     */
    text: string;
    /**
     * 任务ID
     */
    task_id: string;
}

export type SummarizeNoveltyInputResponse = string;

/**
 * 异步总结技术要点响应
 */
export interface NoveltyInputSummaryAsyncResponse {
    /**
     * 任务状态：SUCCESS, FAILED, RUNNING
     */
    status: 'SUCCESS' | 'FAILED' | 'RUNNING';
    /**
     * 总结结果（当 status 为 SUCCESS 时返回）
     */
    result?: SummarizeNoveltyInputResponse;
    /**
     * 错误信息（当 status 为 FAILED 时返回）
     */
    error_message?: string;
    /**
     * 任务ID
     */
    task_id: string;
}

/**
 * 总结技术要点 API
 */
export interface NoveltyInputSummaryApi {
    /**
     * 总结输入中的技术要点
     * @param data 请求参数
     * @param signal abort 信号
     * @returns 异步总结响应
     */
    summarizeNoveltyInput(data: SummarizeNoveltyInputRequest, signal?: AbortSignal): Promise<NoveltyInputSummaryAsyncResponse>;
}

export const NoveltyInputSummaryApi = Symbol.for('NoveltyInputSummaryApi');
